module.exports = __webpack_public_path__ + "static/media/calendar-2.ffc92a6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calendar-2.svg
// module id = 1482
// module chunks = 1